import Swiper from 'swiper'

class MySwiper2 {
	constructor() {
		document.querySelectorAll('[data-swiper]').forEach(el => {
			this._init(el)
		})
	}
	_init(el) {
		let options = {
			loop: true,
			slidesPerView: 2,
			breakpoints: {
				800: {
				  slidesPerView: 1,
				  spaceBetween: 0
				}
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			autoplay: {
				delay: 5000,
			},
		}

		this.swiper = new Swiper(el.querySelector('.swiper-container'), options)
	}
}

export default MySwiper2